import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerMain = styled.div`
  box-sizing: border-box;
  position: relative;
  padding: 5% 0;
  width: 100%;
  min-height: 100vh;
  background-color: #3f8cff;

  /* @media (max-width: 1366px) {
    padding: 8% 0;
  } */
`;

export const ContainerImageBack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 80px auto;
  width: 95%;
  min-height: 80vh;
  background-color: ${Variables.colorWhite};
  border-radius: 10px;
  align-self: center;
  background-image: url("/home/imageBackMain.png");
  background-repeat: no-repeat;
  background-size: cover;

  /* @media (max-width: 1440px) {
    margin-top: 60px;
    width: 90%;
  } */
`;

export const Title = styled.p`
  margin-top: 40px;
  font-size: 40px;
  font-weight: 700;

  /* @media (max-width: 1366px) {
    margin: 40px 0;
  } */
`;

export const ContainPillars = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
  margin: 40px 0;
  width: 80%;
`;

export const Pillar = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 10px;
  width: 100%;
  min-height: 100px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  @media (min-width: 1024px) {
    width: 48%;
  }

  @media (min-width: 1440px) {
    width: 32%;
  }
`;

export const ContainerCheck = styled.div`
  display: flex;
  justify-content: center;
  width: 10%;
  height: 100%;
`;

export const ContainerPillarDescription = styled.div`
  position: relative;
  padding-top: 5px;
  width: 90%;
  height: 100%;
`;

export const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const TitlePillar = styled.p`
  font-weight: 600;
`;

export const LinePillar = styled.div`
  margin: 10px 0;
  margin-left: 10px;
  width: 80%;
  height: 0;
  ${({ color }) => color && `border: 1px solid ${color};`}
`;

export const Description = styled.div`
  margin: 10px 0;
  width: 100%;
`;
